import {
  Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit,
  HostListener, ChangeDetectorRef, Input
} from '@angular/core';
import { Subject } from 'rxjs';

import { AngularResizeEventModule, ResizedEvent } from 'angular-resize-event';
import { BuySellServiceType } from '@app/shared/types';
import { RequestWalletDetails } from '@app/shared/models';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-request-wallet-detail-mode',
    imports: [
        CommonModule,
        TranslateModule,
        AngularResizeEventModule
    ],
    templateUrl: './request-wallet-detail-mode.component.html',
    styleUrls: ['./request-wallet-detail-mode.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestWalletDetailModeComponent implements OnInit, AfterViewInit {
  @ViewChild('walletsView') walletsView: ElementRef;

  @Input() selectedWallet: RequestWalletDetails;
  // is buy or sell service and can be null
  @Input() buySellServiceType: BuySellServiceType;

  unsubscribeAll$ = new Subject<void>();

  // style
  isMobileSize: boolean;
  walletClass: string;

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  /*******************************************************************
   Life Cycle
  *******************************************************************/

  ngOnInit(): void {
    this.onResize();
    this.mangeWallets();
  }

  ngAfterViewInit(): void {
    if (this.walletsView) {
      this.walletClass = this.getClass(this.walletsView.nativeElement.offsetWidth);
      this.cdr.detectChanges();
    }
  }

  /*******************************************************************
   Fetch Data
  *******************************************************************/
  mangeWallets(): void {

    if (this.selectedWallet) {
      return;
    }

  }


  /*******************************************************************
   General
  *******************************************************************/

  onResized(event: ResizedEvent) {
    this.walletClass = this.getClass(event.newRect.width);

  }

  getClass(width: number): string {
    if (width < 510) {
      return 'wallet-xs';
    }

    if (width < 728) {
      return 'wallet-sm';
    }

    /*     if (width < 1027) {
          return ('wallet-md');
        }  */

    if (width < 1500) {
      return 'wallet-md';
    }

    if (width > 1499) {
      return 'wallet-lg';
    }
  }



  @HostListener('window:resize', ['$event'])
  onResize($event?) {
    if (window.innerWidth < 993) {
      this.isMobileSize = true;
    } else {
      this.isMobileSize = false;
    }

  }

}
